"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: block;\n    position: absolute;\n    transform: translateY(50%);\n    right: 0;\n    width: 24px;\n    height: 24px;\n    transition-property: opacity;\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      height = _ref.height,
      disabled = _ref.disabled,
      hover = _ref.hover;
  var palette = theme.palette;
  return {
    bottom: height / 2 + 'px',
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    cursor: disabled ? 'no-allowed' : 'pointer',
    opacity: disabled ? palette.iconOpacityDisabled : hover ? palette.iconOpacityHover : palette.iconOpacity
  };
};

var Calendar = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
});

var _default = Calendar;
exports["default"] = _default;